import { useState } from "react";
import { validateEmail } from "../utils";

const useEmailField = (initialValue = "", formErrors = null, setFormErrors = null) => {
  const [email, setEmail] = useState({
    value: initialValue,
    error: null,
  });

  const handleEmailChange = (e) => {
    const value = e.target.value;
    const isValid = validateEmail(value);
    setEmail({ value, error: !isValid });
  };

  const handleEmailChangeWithClear = (e) => {
    handleEmailChange(e);
    const isValid = validateEmail(e.target.value);
    if (isValid && formErrors?.email && setFormErrors) {
      setFormErrors((prev) => ({ ...prev, email: "" }));
    }
  };

  return {
    email,
    setEmail,
    handleEmailChange,
    handleEmailChangeWithClear,
    isEmailValid: email.value && !email.error,
  };
};

export default useEmailField;
